import {PermissionEditor} from '../../users/components/permissions/PermissionEditor'
import {useIntl} from 'react-intl'
import {ONE_USER_MESSAGES as M} from '../oneUserMessages'

// A single user's permissions (Overview → Permissions tab). Reuses the shared
// subject-focused editor locked to this user (Inherit / Allow / Deny overrides).
export const UserPermissionsTab = ({userId, userName}: {userId: number | string; userName?: string}) => {
  const intl = useIntl()
  return (
    <div className='card'>
      <div className='card-header'>
        <h3 className='card-title mb-0'>
          {userName
            ? intl.formatMessage(M.permissionsTitleFor, {name: userName})
            : intl.formatMessage(M.permissionsTitle)}
        </h3>
      </div>
      <div className='card-body'>
        <PermissionEditor
          lockedUser={{
            id: String(userId),
            name: userName || intl.formatMessage(M.permissionsFallbackName, {id: userId}),
          }}
        />
      </div>
    </div>
  )
}
